import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import AuthenticationSkeleton from ".././skeletons/pagesSpecific/Login/AuthenticationSkeleton";

// NOTE: Component to protect client routes
export const ProtectedClientRoute = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, mustResetPassword } = useSelector(
    (state) => state.auth
  );

  // If not authenticated, show sign-in modal
  if (!isAuthenticated) {

    // Render a blank outlet that will show the current route's UI
    // in the background while the modal is displayed on top
    return <AuthenticationSkeleton />;
  }

  // If user must reset password, force them to reset and block other protected routes
  if (mustResetPassword) {
    return <Navigate to="/reset-password" replace />;
  }

  return <Outlet />;
};

// NOTE: Handle Public Routes
export const PublicRoute = () => {
  return <Outlet />;
};

// NOTE: Admin Route Protection
export const AdminRoute = ({ children }) => {
  const { isAuthenticated, admin } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated || !admin) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // If user is on root path and authenticated, redirect to admin dashboard
  if (location.pathname === '/') {
    return <Navigate to="/admin" replace />;
  }

  return children ? children : <Outlet />;
};